import { useRouter } from 'next/router'
import { useQuery } from 'react-query'
import { getCertificateService } from 'services/certificates'
import useSession from './session'

export async function prefetchCertificate({ queryClient, uuid, token }) {
  const userToken = token || ''
  await queryClient.prefetchQuery(
    ['CERTIFICATE', uuid, userToken],
    () => getCertificateService({ uuid, token }),
  )
  return queryClient
}

export function useCertificate() {
  const { query: { certificate_uuid: uuid } } = useRouter()
  const { token } = useSession()
  return useQuery(
    ['CERTIFICATE', uuid, token],
    () => getCertificateService({ uuid, token }),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  )
}
